import { useState, useCallback, useRef, useEffect } from "react";
import { useAppSelector } from "../../../../../utils/hooks/hooks";
import { RootState } from "../../../../../store/app";
import { Button, message, Typography, Table, Input, Space } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { renderNA, } from "../../../../../utils/commonFunctions";
import { SearchOutlined } from '@ant-design/icons';
import type { InputRef, TableColumnsType, TableColumnType } from 'antd';
import type { FilterDropdownProps } from 'antd/es/table/interface';
import { Tag } from 'antd';
import ContentBox from "../../../../../components/ContentBox/ContentBox";

import AccessCodeColumnDefs from "./AccessCodeColumnDefs";
import AgGridWrapper from "../../../../../components/AgGridWrapper/AgGridWrapper";
import { setGrid, setAccessCodesGrid } from "../../utils/slice";
import { AgGridReact } from "ag-grid-react";
import Config from "../../../../../config/Config";
import React from "react";
const { Title, Link } = Typography;

/**
 * Renders the Listing component for AccessCodeListing module.
 *
 * @return {JSX.Element} The rendered Listing component.
 */


const AccessCodeListing: React.FC<any> = () => {
    const customerAccessDetails = useAppSelector((state: RootState) => state.customerAccess.details);

    const statusAll = [
        { color: '#108ee9', title: 'Available', disabled: '0' },
        { color: 'green', title: 'Registered', disabled: '1' },
        { color: '#87d068', title: 'Invited', disabled: '1' },
        { color: '#FF0000', title: 'Expired', disabled: '1' },
    ]

    const statusFileds = (index: number, type: string) => {
        const i = (customerAccessDetails.is_completed == 'Completed' && index != 2) ? 3 : index;

        if (type == 'color') {
            return statusAll[i].color;
        }
        else if (type == 'disabled') {
            return statusAll[i].disabled;
        }
        else {
            return statusAll[i].title;
        }
    }




    const [statusData, setStatusData] = useState<any>(null);
    const [rowData, setRowData] = useState([]);
    useEffect(() => {
        setStatusData({
            reportingCurrency: "EUR",
        })
        setRowData(customerAccessDetails.access_codes);
        return () => {
            setStatusData(null)
            setRowData([])
        }
    }, [])


    const ActionRenderer = (props: any) => {
        return (<></>);
    };



    return (
        <>
            <ContentBox>

                <AgGridWrapper
                    components={{
                        ActionRenderer,
                    }}
                    className="access-code-table"
                    columnDefs={AccessCodeColumnDefs()}
                    rowData={rowData}
                    // context={{ setStatusData }}
                    onGridReadyWithDispatch={setAccessCodesGrid}
                    paginationPageSize={10}
                    cacheBlockSize={10}

                />
            </ContentBox>



        </>
    );
};

export default AccessCodeListing;
